/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903853583 — Знижки */

import { getCurrencyBySubUnits } from '../../../../../shared';
import { useAppStore } from '../../../../../shared/hooks/useAppStore';
import { useDiscountedPrice } from '../../../hooks';
import { PriceDisplay } from '../PriceDisplay';

export function PriceCT1({ className }: { className?: string }) {
    const vm = useAppStore((store) => store.vm);
    const order = useAppStore((store) => store.order);

    // CT1: PHP writes order.amount (post-discount) and order.originalAmount
    // (pre-discount, when a campaign is active). FE only converts + subtracts.
    const discountedAmountInSubunits = order.amount ?? 0;

    const originalAmountCurrency = order.originalAmount
        ? getCurrencyBySubUnits(order.originalAmount)
        : undefined;

    const priceView = useDiscountedPrice({
        amountInSubunits: discountedAmountInSubunits,
        inputAmount: originalAmountCurrency,
        discountPercentage: vm?.campaign?.discount_percentage,
    });

    return (
        <PriceDisplay
            className={className}
            totalAmount={priceView.discountedAmount}
            originalAmount={priceView.originalAmount}
            savings={priceView.savings}
            currencyCode={vm?.currency_code}
            campaignMessage={vm?.campaign?.message}
            discountPercentage={vm?.campaign?.discount_percentage}
            startHour={vm?.campaign?.start_hour}
            endHour={vm?.campaign?.end_hour}
        />
    );
}
